<template>
  <v-container fluid>
    <v-layout row wrap>
      <div class="markdown" v-html="content"></div>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  components: {},
  computed: {
    ...mapGetters(['getServer', 'getTokenHeader'])
  },
  props: ['show'],
  data() {
    return {
      content: ''
    }
  },
  watch: {
    show() {
      this.getItem()
    }
  },
  created() {
    this.getItem()
  },

  methods: {
    getItem() {
      const lang = this.$i18n.locale
      const server = 'https://dashboard.trawlingweb.com/api'
      this.$http
        .get(`${server}/faqs/${lang}/${this.show}`, this.getTokenHeader)
        .then(datacontent => {
          this.content = datacontent.data
        })
        .catch(() => {
          this.content = ''
        })
    }
  }
}
</script>
